var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenNewTab(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#457AE6",
    d: "M13.3638 0H8.27286C7.92141 0 7.63649 0.284922 7.63649 0.636371C7.63649 0.98782 7.92141 1.27274 8.27286 1.27274H11.8275L5.27746 7.82277C5.02893 8.0713 5.02893 8.47418 5.27746 8.72271C5.40168 8.84696 5.56454 8.90909 5.7274 8.90909C5.89026 8.90909 6.05315 8.84699 6.1774 8.72268L12.7274 2.17268V5.72729C12.7274 6.07873 13.0124 6.36366 13.3638 6.36366C13.7152 6.36366 14.0002 6.07873 14.0002 5.72729V0.636371C14.0001 0.284922 13.7152 0 13.3638 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#457AE6",
    d: "M10.8182 6.36357C10.4667 6.36357 10.1818 6.64849 10.1818 6.99994V12.7272H1.27271V3.81811H7C7.35145 3.81811 7.63637 3.53319 7.63637 3.18174C7.63637 2.83029 7.35145 2.54539 7 2.54539H0.636371C0.284922 2.54539 0 2.83032 0 3.18177V13.3636C0 13.715 0.284922 13.9999 0.636371 13.9999H10.8182C11.1696 13.9999 11.4546 13.715 11.4546 13.3636V6.99994C11.4545 6.64849 11.1696 6.36357 10.8182 6.36357Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenNewTab);
export default __webpack_public_path__ + "static/media/open-new-tab.e8d217ccdba42ef469f540370b4e629c.svg";
export { ForwardRef as ReactComponent };